import React from 'react';

const ProductsList = ({
  selectedWarehouse,
  selectedProducts,
  onAddClick,
  updateQuantity,
  updateReason,
  removeProduct,
  calculateTotal,
  notes,
  onNotesChange,
  loading,
  onSubmit,
}) => (
  <>
    <button
      style={{
        width: '100%',
        padding: '6px 12px',
        fontSize: '12px',
        fontWeight: '500',
        border: '1px solid var(--success)', color: 'var(--success)' ,
        cursor: 'pointer',
        marginBottom: '0.5rem',
      }}
      onClick={onAddClick}
      disabled={!selectedWarehouse}
    >
      &#x2795; Dodaj produkt do wydania
    </button>

    {selectedProducts.length > 0 && (
      <div style={{
        backgroundColor: 'var(--bg)',
        borderRadius: '4px',
        padding: '0.5rem',
        marginBottom: '0.5rem',
        border: '1px solid var(--border)',
      }}>
        <div style={{ fontSize: '11px', fontWeight: '600', marginBottom: '0.4rem' }}>
          &#x1F4E6; Produkty do wydania ({selectedProducts.length})
        </div>

        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {selectedProducts.map((product) => (
            <div
              key={product.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.4rem',
                padding: '0.35rem',
                backgroundColor: 'var(--card-bg)',
                borderRadius: '3px',
                marginBottom: '0.3rem',
                border: '1px solid var(--border)',
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '500', fontSize: '11px' }}>{product.name}</div>
                <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
                  Dost&#x119;pne: {product.maxQuantity} {product.jednostka || 'szt.'}
                </div>
              </div>
              <input
                type="number"
                min="1"
                max={product.maxQuantity}
                step="0.01"
                value={product.quantity}
                onChange={(e) => updateQuantity(product.id, e.target.value)}
                style={{
                  width: '60px',
                  padding: '0.2rem',
                  fontSize: '11px',
                  border: '1px solid var(--border)',
                  borderRadius: '3px',
                  textAlign: 'center',
                }}
              />
              <input
                type="text"
                placeholder="Pow&#xF3;d"
                value={product.reason}
                onChange={(e) => updateReason(product.id, e.target.value)}
                style={{
                  width: '120px',
                  padding: '0.2rem',
                  fontSize: '11px',
                  border: '1px solid var(--border)',
                  borderRadius: '3px',
                }}
              />
              <button
                onClick={() => removeProduct(product.id)}
                style={{
                  padding: '4px 10px',
                  fontSize: '11px',
                  border: '1px solid var(--danger)', color: 'var(--danger)' ,
                  cursor: 'pointer',
                }}
              >
                &#x2715;
              </button>
            </div>
          ))}
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '0.5rem',
          paddingTop: '0.5rem',
          borderTop: '1px solid var(--border)',
        }}>
          <span style={{ fontWeight: '600', fontSize: '12px' }}>
            Razem: {calculateTotal().toFixed(2)} z&#x142;
          </span>
        </div>
      </div>
    )}

    <div style={{ marginBottom: '0.5rem' }}>
      <label style={{ display: 'block', fontSize: '10px', color: 'var(--text-muted)', marginBottom: '2px' }}>
        Uwagi (opcjonalnie)
      </label>
      <textarea
        value={notes}
        onChange={(e) => onNotesChange(e.target.value)}
        placeholder="Dodatkowe informacje..."
        rows={2}
        style={{
          width: '100%',
          padding: '0.3rem',
          fontSize: '11px',
          border: '1px solid var(--border)',
          borderRadius: '3px',
          resize: 'vertical',
        }}
      />
    </div>

    <button
      style={{
        width: '100%',
        padding: '6px 12px',
        fontSize: '12px',
        fontWeight: '600',
        backgroundColor: selectedProducts.length > 0 ? 'var(--info)' : 'var(--text-muted)',
        color: '#fff' ,
        cursor: selectedProducts.length > 0 ? 'pointer' : 'not-allowed',
        opacity: loading ? 0.7 : 1,
      }}
      onClick={onSubmit}
      disabled={selectedProducts.length === 0 || loading}
    >
      {loading ? '⏳ Zapisywanie...' : '✅ Zarejestruj wydanie zewnętrzne'}
    </button>
  </>
);

export default ProductsList;
